const bogusWebCrypto = [
    { hash: { name: 'SHA-256' }, name: 'HMAC' },
    true,
    ['sign'],
];
export default bogusWebCrypto;
